<template>
  <Transition name="fade-modal">
    <div
      v-if="isVisible"
      class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm"
      @click.self="close"
    >
      <div
        class="modal-content relative w-full max-w-[400px] p-6 rounded-2xl crystal-card border border-nirvana-lotus/30 shadow-2xl shadow-nirvana-lotus/20 bg-[#0B0D17]/95"
      >
        <button
          @click="close"
          class="absolute top-4 right-4 text-nirvana-silver/40 hover:text-nirvana-white transition-colors"
          aria-label="Close tutorial"
        >
          <X class="w-5 h-5" />
        </button>

        <div class="flex flex-col items-center text-center gap-4 mt-2">
          <div class="p-4 rounded-2xl bg-gradient-to-br from-nirvana-lotus/20 to-nirvana-cyan/10 border border-nirvana-lotus/30 text-nirvana-lotus shadow-inner">
            <ArrowUpRightSquare class="w-10 h-10" />
          </div>
          
          <div class="space-y-2 mb-2">
            <h4 class="font-bold text-nirvana-white text-lg">ดูการ์ดแบบเต็มจอ ✨</h4>
            <p class="text-[15px] text-nirvana-silver/70 leading-relaxed font-light px-2">
              น้องเนอสามารถคลิกที่ปุ่มนี้บนการ์ดอวยพร เพื่อเข้าสู่หน้าอ่านการ์ดแบบเต็มจอและเลื่อนอ่านการ์ดใบอื่นๆ ได้อย่างง่ายดายเลยน้าาา!
            </p>
          </div>
          
          <button @click="close" class="lotus-button w-full justify-center">
            เข้าใจแล้ว
          </button>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { ArrowUpRightSquare, X } from 'lucide-vue-next'

const isVisible = ref(false)

onMounted(() => {
  const hasSeenTutorial = localStorage.getItem('hasSeenWishCardTutorial')
  if (!hasSeenTutorial) {
    setTimeout(() => {
      isVisible.value = true
    }, 2500)
  }
})

function close() {
  isVisible.value = false
  localStorage.setItem('hasSeenWishCardTutorial', 'true')
}
</script>

<style scoped>
.fade-modal-enter-active,
.fade-modal-leave-active {
  transition: opacity 0.3s ease;
}

.fade-modal-enter-active .modal-content,
.fade-modal-leave-active .modal-content {
  transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

.fade-modal-enter-from,
.fade-modal-leave-to {
  opacity: 0;
}

.fade-modal-enter-from .modal-content,
.fade-modal-leave-to .modal-content {
  transform: translateY(20px) scale(0.95);
}
</style>
